import * as React from 'react'

import { GlobalVideoGallery } from '@thg-commerce/enterprise-network/src/generated/graphql'
import { spacing, styled } from '@thg-commerce/gravity-theme'
import {
  VideoGallery,
  VideoGalleryProps,
} from '@thg-commerce/enterprise-widget-video-gallery'
import { HorizontalAlignment } from '@thg-commerce/enterprise-core'

import { BaseWidgetProps } from '../types'

export type VideoGalleryRendererProps = BaseWidgetProps &
  Omit<GlobalVideoGallery, 'query'>

const StyledVideoGallery = styled(VideoGallery)`
  margin: 0 auto ${spacing(5)};
  max-width: ${(props) => props.theme.site.siteWidth};
`

const ITEMS_STRING_INDEXES_ARRAY = [
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
]

export const VideoGalleryRenderer = (props: VideoGalleryRendererProps) => {
  const videoGalleryProps: VideoGalleryProps = {
    title: props.title || undefined,
    subtitle: props.textBlock || undefined,
    items: ITEMS_STRING_INDEXES_ARRAY.filter(
      (item) => props[`item${item}VideoURL`] && props[`item${item}Image`],
    ).map((itemStringIndex) => ({
      previewImage: {
        url: { large: props[`item${itemStringIndex}Image`] },
        alt: props[`item${itemStringIndex}ImageAltText`],
      },
      title: props[`item${itemStringIndex}Title`] || undefined,
      buttonText: props[`item${itemStringIndex}CTA`] || undefined,
      buttonLink: props[`item${itemStringIndex}ButtonLink`] || undefined,
      videoUrl: props[`item${itemStringIndex}VideoURL`],
    })),
    itemsContentAlignment:
      (props.textAlign as HorizontalAlignment) || undefined,
    useTitleHeadingLevel2: props.useTitleHeadingLevel2 || false,
  }

  return <StyledVideoGallery {...videoGalleryProps} />
}
